import { DateRangeFieldsNames } from "ui/common/components/input/DateRangeFields/DateRangeFields.types";

export enum TransactionsFiltersTypes {
    START_DATE = "startDate",
    END_DATE = "endDate",
    TX_MODE = "mode",
}

export interface TransactionsFilters {
    [DateRangeFieldsNames.START_DATE]: string;
    [DateRangeFieldsNames.END_DATE]: string;
    [TransactionsFiltersTypes.TX_MODE]: string;
}

export enum SendStateNames {
    AMOUNT = "amount",
    DESTINATION_ADDRESS = "destinationAddress",
    CONCEPT = "concept",
    REFERENCE = "reference",
    PAYMENT_ID = "paymentId",
}

export interface SendState {
    /**
     * Amount to send
     */
    amount: string;
    /**
     * Address to send to
     */

    otp: string;

    destinationAddress: string;
    receiverFullName?: string;
    /**
     * Concept of the transaction (memo)
     */
    concept?: string;
    /**
     * Reference of the transaction
     */
    reference?: string;
    /**
     * Payment ID of the transaction
     */
    paymentId?: string;

    blockTimestamp?: string;
    
    receiptId?: string;

    transactionHash?: string;
}
